import React from 'react';
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types';
import styled from 'styled-components';

const modalRoot = document.getElementById('modal-root');
const Container = styled.div`
  background-color: rgba(0,0,0,0.5);
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalDialog = styled.div`
  margin: 10px !important;
`;

class Modal extends React.Component {
  el = document.createElement('div');

  componentDidMount() {
    modalRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    modalRoot.removeChild(this.el);
  }

  renderModal() {
    const {title, body, footer, onClose} = this.props;
    return (
      <Container>
        <ModalDialog className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header modal-header-primary">
              <button
                type="button"
                onClick={onClose}
                className="close"
                aria-hidden="true">&times;</button>
              <h4 className="modal-title">{title}</h4>
            </div>
            <div className="modal-body">
              {body}
            </div>
            <div className="modal-footer">
              {footer}
            </div>
          </div>
        </ModalDialog>
      </Container>
    )
  }

  render() {
    return this.props.show
      ? ReactDOM.createPortal(this.renderModal(), this.el)
      : null;
  }
}

Modal.defaultProps = {
  show: false,
  title: null,
  body: null,
  footer: null
};

Modal.propTypes = {
  show: PropTypes.bool,
  title: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  body: PropTypes.element,
  footer: PropTypes.element,
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal.js